import { ethers } from 'ethers';
import { useNavigate } from 'react-router-dom';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { Flexbox } from '../action/Flexbox';
import { useModal } from '../modal/ModalContext';
import ThemeLogo from '../theme/ThemeLogo';

import { useState } from 'react';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { truncateEthereumAddress } from '../../utils';
import './Navbar.scss';
import UserDropdown from './UserDropdown';

const MobileNavbar = () => {
  const [{ user }] = useGlobalState();
  const [{ openModal, isOpen }] = useModal();
  const { userLogout } = useLoginHelper();
  const [searchTerm, setSearchTerm] = useState();
  const [searchResult, setSearchResult] = useState();
  const [isHovering, setIsHovering] = useState();
  const history = useNavigate();

  function onMouseEnter() {
    setIsHovering(true);
  }
  function onMouseLeave() {
    setIsHovering(false);
  }

  function updateSearch(value) {
    setSearchTerm(value);
    if (ethers.isAddress(value)) {
      setSearchResult([{ name: truncateEthereumAddress(value), address: value }]);
    } else {
      setSearchResult(null);
    }
  }

  function handleSearchClick() {
    if (ethers.isAddress(searchTerm)) {
      setSearchTerm('');
      setSearchResult(null);
      history(`/profile/${searchTerm}/projects`);
    }
  }

  function handleRedirect() {
    history(`/profile/${user?.address}/projects`);
  }
  return (
    <section className='navbar_container'>
      <Flexbox className='navbar_container__content' justifyContent='space-between'>
        <Flexbox className='navbar_container__content__left' alignItems='center' gap='0.5rem'>
          <ThemeLogo onClick={handleRedirect} className='pointer' icon={'mercleLogoMobile'} />
        </Flexbox>
        <Flexbox>
          <ThemeLogo className='pointer' icon={'oniontakes'} />
          <UserDropdown />
        </Flexbox>
      </Flexbox>
    </section>
  );
};

export default MobileNavbar;
